module.exports = __webpack_public_path__ + "static/media/help.41986e11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/help.svg
// module id = 4017
// module chunks = 0